function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "sprout-ui-dom/dist/Button";
import styled from "styled-components";
import { ArrowDropDown } from "sprout-ui-icons";
import { useMenuState, Menu, MenuTrigger } from "@sprout/list-navigation/dist/Menu";
import { SearchScope } from "../types";
import SearchMenuItem from "./Search_Menu_Item";
const SearchMenuButton = styled(Button)`
  width: 24px;
  height: 24px;
`;
const StyledArrowDropDown = styled(ArrowDropDown)`
  transition: transform 0.2s ease;
  ${({ $expand  })=>$expand && `transform: rotate(-180deg);`}
`;
const SearchMenu = ()=>{
    const menuState = useMenuState();
    const { open  } = menuState;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(SearchMenuButton, {
                    variant: "circle",
                    children: /*#__PURE__*/ _jsx(StyledArrowDropDown, {
                        $expand: !!open
                    })
                })
            })),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                $size: "200px",
                children: [
                    /*#__PURE__*/ _jsx(SearchMenuItem, {
                        action: "SEARCH_MY_TOPICS",
                        searchScope: SearchScope["my-trees"]
                    }),
                    /*#__PURE__*/ _jsx(SearchMenuItem, {
                        action: "SEARCH_SPROUT",
                        searchScope: SearchScope.sprout
                    }),
                    /*#__PURE__*/ _jsx(SearchMenuItem, {
                        action: "SEARCH_PEOPLE",
                        searchScope: SearchScope.people
                    })
                ]
            }))
        ]
    });
};
export default SearchMenu;
